<template>
  <div id="index-home">
    <router-view/>
    <!-- <div class="zsy-logo-div">
      <van-image round width="30px" height="30px" src="http://file.wisewater.cn/group1/M01/0E/DC/rBAABWBu1ZiAH5SbAACdwpgAUuI315.png" />
    </div> -->
    <van-tabbar v-model="active" route class="index-bottom">
      <van-tabbar-item replace to="/index/home" icon="home-o">营业厅</van-tabbar-item>
      <van-tabbar-item replace to="/index/about" icon="friends-o">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import Vue from 'vue'
import { Tabbar, TabbarItem } from 'vant'

Vue.use(Tabbar)
Vue.use(TabbarItem)
export default {
  data () {
    return {
      active: 0
    }
  },
  created () {
    // console.log(this.$cookies.get('token'))
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
</style>
